import images from "common/images";
import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import "./index.scss";
import { Icon } from "shared";

type TabItemProps = {
  tab: any;
  onClick: () => void;
  onDuplicate: () => void;
  onEditTab: () => void;
};

const TabItem = ({ tab, onClick, onDuplicate, onEditTab }: TabItemProps) => {
  const [isOpen, setOpen] = useState(false);
  const toggle = (e: any) => {
    e.stopPropagation();
    setOpen(!isOpen);
  };
  const editable =
    tab.scope !== "system" ||
    tab.code === "store_information_tab" ||
    tab.code === "rental_info_tab";
  return (
    <div
      className="tab-item-container"
      onClick={editable ? onClick : undefined}
      style={{ opacity: tab.is_show ? 1 : 0.5 }}
    >
      <div className={`tab-item ${editable ? "normal-button" : ""}`}>
        <i className="material-icons drag-icon">drag_handle</i>
        <div style={{ width: 5 }} />
        {/* <img src={images.blueFolder} className="tab-image" /> */}
        <span className="tab-name">{tab.name}</span>
        <div style={{ flex: 1 }} />
        <Dropdown isOpen={isOpen} toggle={toggle} direction="up">
          <DropdownToggle className="more-button">
            <Icon name="more_horiz" size="medium" />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={onDuplicate}>Duplicate</DropdownItem>
            <DropdownItem onClick={onEditTab}>Edit tab</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
};

export default TabItem;
